import { UserService } from 'app/service/auth/user.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Validate } from 'app/lib/validate';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  animations : fuseAnimations
})
export class ChangePasswordComponent implements OnInit 
{
    resetSenha: boolean = false;
    changePasswordForm: FormGroup;
    // Private
    private _unsubscribeAll: Subject<void>;
    loading:boolean = false;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private toastr: ToastrService,
        private userSvc: UserService,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private router: Router,
    ) 
    { 
         // Configure the layout
         this._fuseConfigService.config = {
            layout: {
                navbar   : { hidden: true },
                toolbar  : { hidden: true },
                footer   : { hidden: true },
                sidepanel: { hidden: true }
            }
        };
    }
    

    ngOnInit(): void 
    {
        this.changePasswordForm = this._formBuilder.group({
            password: ['', Validators.required],
            passwordNew: ['', [Validators.required, Validators.minLength(8), Validate.password]],
            passwordConfirm: ['', [Validators.required]]
        }, 
            { validator: confirmPasswordValidator('passwordNew', 'passwordConfirm') }
        );
        if(this.userSvc.getUser() != null){
            if(this.userSvc.getUser().resetSenha === 'true'){
                this.resetSenha = false;
            } else {
                this.resetSenha = true;
            }
        }
    }

   

    send(){
        if(this.changePasswordForm.valid){
            this.loading = true;
            this.userSvc.changePassword(this.changePasswordForm.value.password, this.changePasswordForm.value.passwordNew)
            .pipe( finalize(()=>this.loading = false) )
            .subscribe(
                v=>{
                    this.toastr.success('Senha alterada com sucesso!', 'Troca de senha'),
                    this.userSvc.updateResetSenha();
                    this.router.navigate(['app']);
                },
                err=>{ 
                    this.toastr.error('A senha atual está incorreta', 'Troca de senha');
                }
            );
        }
    }
}

export function confirmPasswordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}